import React from "react";
import Table from "../../../../../components/coreUiTable/Table"
import { connect } from "react-redux";

function formatData(colHeaders) {
  let slots = {
    scopedSlots: {},
    columnHeaderSlot: {}
  }
  colHeaders.forEach(colHeader=>{
    slots = {
      ...slots,
      scopedSlots: {
        ...slots.scopedSlots,
        [colHeader]: (item)=>{
          return <td><div dangerouslySetInnerHTML={{__html: item[colHeader]}}/></td>
        }
      },
      columnHeaderSlot: {
        ...slots.columnHeaderSlot,
        [colHeader]: <div className="d-inline" dangerouslySetInnerHTML={{__html:colHeader}}/>
      }
    }
  })
  return slots
}
function addTotal(data, total ){
  if(Array.isArray(total)){
    data.push(total)
    return data
  }
}
export default connect(state => {
  const {membershipsInfo: {colHeaders, data}, totalMembersCount} = state.membershipBreakdown;
  addTotal(data, totalMembersCount)
  const { scopedSlots , columnHeaderSlot}  = formatData(colHeaders)

  return {
   tableFilter: false,
   pagination: false,
   columnHeaderSlot,
   table: {colHeaders, data},
   scopedSlots: scopedSlots
  };
})(Table);
